import { render, staticRenderFns } from "./ProductLabelBulkAttachLabel.vue?vue&type=template&id=ba373b24&"
import script from "./ProductLabelBulkAttachLabel.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBulkAttachLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports